import { Navigate } from 'react-router-dom'

export function ExpiredRouteRedirect() {
  return <Navigate to="/expired" replace />
}
